import React from 'react';
import styled from 'styled-components';
import clsx from 'clsx';
import { Paper, paperClassNames } from '@moonsifttech/design-system';

import { CreatorDialogProps } from './CreatorDialog.types';

export const creatorDialogClassNames = {
  variantShadow: 'CreatorDialog-variantShadow',
};

const UnstyledCreatorDialog: React.FC<CreatorDialogProps> = ({
  className,
  style,
  variant,
  children,
  ...otherProps
}) => {
  const paperVariant = variant === 'standard' ? 'standard' : 'outlined';
  return (
    <Paper
      className={clsx(
        className,
        variant === 'shadow' && creatorDialogClassNames.variantShadow,
      )}
      style={style}
      variant={paperVariant}
      {...otherProps}
    >
      {children}
    </Paper>
  );
};

export const CreatorDialog = styled(UnstyledCreatorDialog)`
  padding: 12px 16px 16px;
  max-width: 312px;

  &.${paperClassNames.variantOutlined}.${creatorDialogClassNames.variantShadow} {
    border: 0;
    background: var(--grey-6);
  }
`;
